import { Rule } from 'antd/lib/form';
import FormInput from 'components/Input/FormInput';
import React, { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

interface IVersionCodeField {
	changeVersionCode: (value: string) => void;
}

const VersionCodeField: React.FC<IVersionCodeField> = ({ changeVersionCode }) => {
	const { t } = useTranslation('error');

	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('enterVersionCode') }], [t]);

	const handleChange = useCallback(
		(e: React.ChangeEvent<HTMLInputElement>) => {
			const onlyDigits = e.target.value.replace(/\D/g, '');
			changeVersionCode(onlyDigits);
			return onlyDigits;
		},
		[changeVersionCode],
	);

	return (
		<FormInput
			testId="VersionCodeField"
			name="versionCode"
			label="versionCodeLabel"
			maxLength={10}
			getValueFromEvent={handleChange}
			validationRules={validationRules}
		/>
	);
};

export default React.memo(VersionCodeField);
